/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { Avatar, Typography } from "@mui/material";
import classes from "../style";

export interface InscriptionInterfaceProps {
  changeInscriptionMode: (mode: string) => void;
  search: String;
}
const Inscription: FC<InscriptionInterfaceProps> = ({
  changeInscriptionMode, search
}: InscriptionInterfaceProps) => {
  const handleLogin = (domain: string = "mail") => {
    if (domain === "mail") return;

    const query = search?.length == 0 ?
      '/'
      :
      '/liste-profils' + search;

    const hostWithProtocol = `${window.location.protocol}//${window.location.host}${query}`;
    if (domain === "google.com") {
      window.location.href = `${process.env.REACT_APP_API_URL.trim()}/api/authentication/signin-google?returnUrl=${hostWithProtocol}`;
    }
    if (domain === "facebook.com") {
      window.location.href = `${process.env.REACT_APP_API_URL.trim()}/api/authentication/signin-facebook?returnUrl=${hostWithProtocol}`;
    }
    if (domain === "linkedin.com") {
      window.location.href = `${process.env.REACT_APP_API_URL.trim()}/api/authentication/signin-linkedin?returnUrl=${hostWithProtocol}`;
    }
    if (domain === "instagram.com") {
      window.location.href = `${process.env.REACT_APP_API_URL.trim()}/api/authentication/signin-instagram?returnUrl=${hostWithProtocol}`;
    }
    if (domain === "tiktok.com") {
      window.location.href = `${process.env.REACT_APP_API_URL.trim()}/api/authentication/signin-tiktok?returnUrl=${hostWithProtocol}`;
    }
  };

  return (
    <Card sx={classes.card}>
      <CardContent>
        <Button
          variant="text"
          onClick={() => changeInscriptionMode("inscriptionMail")}
        >
          <Avatar alt="Message" src="/static/images/icons/message.png" />
          Continuer avec une adresse mail
        </Button>
        <Typography sx={classes.centered}>ou</Typography>
        <Button variant="text" onClick={() => handleLogin("facebook.com")}>
          <Avatar alt="Facebook" src="/static/images/icons/facebook.png" />
          Continuer avec Facebook
        </Button>
        <Button variant="text" onClick={() => handleLogin("google.com")}>
          <Avatar alt="Google" src="/static/images/icons/google.png" />
          Continuer avec Gmail
        </Button>
        {/* <Button variant="text" onClick={() => handleLogin("instagram.com")}>
          <Avatar alt="Instagram" src="/static/images/icons/instagram.png" />
          Continuer avec Instagram
        </Button> */}
        <Button variant="text" onClick={() => handleLogin("linkedin.com")}>
          <Avatar alt="LinkedIn" src="/static/images/icons/linkedin.png" />
          Continuer avec LinkedIn
        </Button>
        {/* <Button variant="text" onClick={() => handleLogin("tiktok.com")}>
          <Avatar alt="TikTok" src="/static/images/icons/tiktok.png" />
          Continuer avec TikTok
        </Button> */}
      </CardContent>
    </Card>
  )
};

export default Inscription;
